import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FullServiceShop() {
  const services = ['Routine maintenance and oil service', '42-point Digital Vehicle Inspection', 'Brake service and suspension repair', 'Hybrid system service and diagnostics', 'Electrical system repairs', 'AC repair and climate systems', 'Transmission and fuel system repairs', 'Tire service and alignment', 'Engine diagnostics and repair', 'Fleet service management'];
  return <section className="py-20 px-4 bg-white" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-82">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-83">
            Full-service Toyota care
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6 pl-[0px] pr-[0px]" data-id="element-84">
            One shop. Everything your Toyota needs.
          </h2>
          <div className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto space-y-4" data-id="element-85">
            <p className="pl-[23px] pr-[23px]" data-id="element-86">
              Routine maintenance, major repairs, hybrid service — it all stays
              in one place. So does your vehicle's history, and so does the
              familiarity with your specific car.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-brand-light rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-12" data-id="element-87">
          <p className="font-bold text-brand-dark text-xl mb-8 text-center" data-id="element-88">
            We provide:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-89">
            {services.map((service, index) => <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-90">
                <CheckIcon className="w-6 h-6 text-brand-accent flex-shrink-0" data-id="element-91" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-92">
                  {service}
                </span>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-12" data-id="element-93">
          <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/20 border border-gray-200" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/cvG4pWzAboEbzBx5WhpFEb/lancer_team.webp" alt="The Lancer Service team standing together in the shop" className="w-full h-auto object-cover" data-id="element-95" />
          </div>
          <p className="text-center text-sm text-gray-500 font-medium mt-4 uppercase tracking-widest" data-id="element-96">
            The Lancer Service team · St. Paul, MN
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-97">
          <p className="text-2xl font-bold text-brand-dark" data-id="element-98">
            Our goal isn't just fixing what's wrong today. It's helping your
            Toyota last as long as you want it to.
          </p>
        </motion.div>
      </div>
    </section>;
}